import { QueryClient } from '@tanstack/react-query';
import { monitoring } from './monitoring';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 2, // 2 minutes - shorter for more frequent updates
      gcTime: 1000 * 60 * 30, // 30 minutes
      refetchOnWindowFocus: true, // Enable refetch when window regains focus
      refetchOnReconnect: true, // Refetch when connection is restored
      retry: (failureCount, error) => {
        // Don't retry on 4xx errors
        if (error instanceof Error && 'status' in error) {
          const status = (error as any).status;
          if (status >= 400 && status < 500) return false;
        }
        return failureCount < 2;
      },
      // Network-based cache strategies
      networkMode: 'online',
    },
    mutations: {
      retry: 1,
      networkMode: 'online',
      onError: (error) => {
        monitoring.captureError(error as Error, {
          context: 'mutation',
        });
      },
    },
  },
  // Global query cache handlers
  queryCache: {
    onError: (error) => {
      monitoring.captureError(error as Error, {
        context: 'query',
      });
    },
  } as any,
});
